
export const error = {
    methods: {
        handleError(error) {
            console.log(error);
            const message = error.message;
            this.$root.$emit('error', message);
        }
    }
  };
  